
jQuery(document).ready(function () {
  wowo();
  appendEle();
  slider();
  scroll();
  click();
  video();
  contentMargin();
  hlsVideo();
  eleHover();
  jQuery(window).on("load", function () {

  });
  jQuery(window).scroll(function () {
    wowo();
    contentMargin();
  });
  jQuery(window).resize(function () {
    contentMargin();
    slider();
  });


  // jQuery('.home-banner:not(".inner-banner")').next().addClass('downAnimated');
  //       var offsetH =parseInt(jQuery('.home-banner:not(".inner-banner")').next().css("margin-top"));
    
  //         jQuery('.home-banner:not(".inner-banner")').next().css("transform", "translateY(-"+ offsetH +"px)");
}).on('click', '.process-item .process-item__text .text:not(.active) .arrow', function(){
  jQuery(this).closest('.text').addClass('active').siblings('.text').removeClass('active')
  console.log(jQuery(this).closest('.text').index())
  jQuery('.process-item__img .img').eq(jQuery(this).closest('.text').index()-1).addClass('active').siblings('.img').removeClass('active')
}).on('click', '.process-item .mobile-arrows div', function(){
  var direction = jQuery(this).data('direction'),
      totalSteps = jQuery('.process-item__img .img').length,
      currentStep = jQuery('.process-item__img .img.active').index(),
      nextIndex = direction === 'back' ? currentStep - 1 : currentStep + 1;
      console.log(nextIndex, totalSteps)
  if(nextIndex < 0){
    nextIndex = totalSteps - 1;
  }else if(nextIndex >= totalSteps){
    nextIndex = 0;
  }
 
  jQuery('.process-item__text .text').eq(nextIndex).addClass('active').siblings('.text').removeClass('active')
  jQuery('.process-item__img .img').eq(nextIndex).addClass('active').siblings('.img').removeClass('active')
});


function slider() {
  if (false && jQuery('.process-items').length > 0) {
    jQuery('.process-items .content:not(".slick-initialized")').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      fade: true,
      nextArrow: "<button type='button' class='slick-next slick-arrow icon-right'></button>",
      prevArrow: "<button type='button' class='slick-prev slick-arrow icon-left'></button>",
    });

    // mouse wheel tigger
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    if (isFirefox) {
      $('.process-items .content').on('DOMMouseScroll', function (e) {
        var delta = e.originalEvent.detail;
    
        var slideCount = $(this)[0].slick["slideCount"];
      var currentIndex = $(this).slick("slickCurrentSlide");
      var totalSildeToShow = $(this)[0].slick.options["slidesToShow"];
      var delta = e.originalEvent.deltaY;
      if (e.originalEvent.detail < 0) {
        if (currentIndex === 0)
          return;

        e.preventDefault();
        $(this).slick('slickPrev');
      } else {
        if (slideCount - totalSildeToShow === currentIndex)
          return;

        e.preventDefault();
        $(this).slick('slickNext');
      }
      });
    } else {
      $('.process-items .content').on('mousewheel', function (e) {
        var delta = e.originalEvent.wheelDelta;
    
        var slideCount = $(this)[0].slick["slideCount"];
        var currentIndex = $(this).slick("slickCurrentSlide");
        var totalSildeToShow = $(this)[0].slick.options["slidesToShow"];
        var delta = e.originalEvent.deltaY;
        if (e.originalEvent.wheelDelta > 0) {
          if (currentIndex === 0)
            return;
  
          e.preventDefault();
          $(this).slick('slickPrev');
        } else {
          if (slideCount - totalSildeToShow === currentIndex)
            return;
  
          e.preventDefault();
          $(this).slick('slickNext');
        }
  
      });
    }

    // $('.process-items .content').on('mousewheel', function (e) {
    //   var slideCount = $(this)[0].slick["slideCount"];
    //   var currentIndex = $(this).slick("slickCurrentSlide");
    //   var totalSildeToShow = $(this)[0].slick.options["slidesToShow"];
    //   var delta = e.originalEvent.deltaY;
    //   if (e.originalEvent.deltaY < 0) {
    //     if (currentIndex === 0)
    //       return;

    //     e.preventDefault();
    //     $(this).slick('slickPrev');
    //   } else {
    //     if (slideCount - totalSildeToShow === currentIndex)
    //       return;

    //     e.preventDefault();
    //     $(this).slick('slickNext');
    //   }

    // });


  }





  if (jQuery('.blockquote-sliders').length > 0) {
    jQuery('.blockquote-sliders .blockquote__slider-items:not(".slick-initialized")').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: true,
      nextArrow: "<button type='button' class='slick-next slick-arrow icon-right'></button>",
      prevArrow: "<button type='button' class='slick-prev slick-arrow icon-left'></button>",
      // autoplay: true,
      // autoplaySpeed: 7000,
      // variableWidth: true,
       cssEase: 'ease-in-out',
      speed: 500,

    });

    jQuery(".blockquote-sliders .slick-current").addClass("move");
    jQuery(".blockquote-sliders .blockquote__slider-items").on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      jQuery(".blockquote-sliders .slick-list").addClass('active');

      jQuery(".blockquote-sliders .slick-current").removeClass("move");
      setTimeout(function () {
        jQuery(".blockquote-sliders .slick-current").addClass("move");
      }, 400);
    });





  }
  if (jQuery('.slider-rotate').length > 0) {
    jQuery('.slider-rotate .slider-rotate__items:not(".slick-initialized")').slick({
      slidesToScroll: 1,
      infinite: false,
      accessibility: false,
      // infinite: true,
      variableWidth: true,
      slidesToShow: 1,
      arrows: true,
      dots: false,
      // centerMode: true,
      // autoplay: true,
      // autoplaySpeed: 7000,
      asNavFor: '.slider-rotate__texts',
      nextArrow: "<button type='button' class='slick-next slick-arrow icon-right'></button>",
      prevArrow: false,
      responsive: [
        {
          breakpoint: 1000000,
          settings: "unslick"
        },

        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            settings: "slick",
            slidesToScroll: 1,
          }

        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          }

        },
      ],
    });
  }
  if (jQuery('.slider-rotate').length > 0) {
    jQuery('.slider-rotate .slider-rotate__texts:not(".slick-initialized")').slick({
      slidesToScroll: 1,
      infinite: false,
      accessibility: false,
      // infinite: true,
      slidesToShow: 1,
      arrows: false,
      dots: false,
      fade: true,
      // centerMode: true,
      // autoplay: true,
      // autoplaySpeed: 7000,
      asNavFor: '.blockquote__slider-items',
    });
  }
  if (jQuery('.product-details  .product-details__images .product-details__image').length > 1) {
    jQuery('.product-details__images .product-details__images-box:not(".slick-initialized")').slick({
      slidesToScroll: 1,
      infinite: false,
      infinite: true,
      slidesToShow: 1,
      arrows: false,
      dots: true,
      // centerMode: true,
      // autoplay: true,
      // autoplaySpeed: 7000,
      responsive: [
        {
          breakpoint: 1000000,
          settings: "unslick"
        },

        {
          breakpoint: 991,
          settings: {

            settings: "slick",
            slidesToScroll: 1,
            slidesToShow: 1,
          }

        },

      ],
    });
  }

  if (jQuery('.logos-slider').length > 0) {
    jQuery('.logos-slider:not(".slick-initialized")').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: true,
      nextArrow: "<button type='button' class='slick-next slick-arrow icon-right'></button>",
      prevArrow: "<button type='button' class='slick-prev slick-arrow icon-left'></button>",
      // autoplay: true,
      // autoplaySpeed: 7000,
      // variableWidth: true,
       cssEase: 'ease-in-out',
      speed: 500,

    });


  }

}

function wowo($) {
  setTimeout(function () {
    jQuery('html').addClass("show-c");


    // if (jQuery('.home-banner:not(".inner-banner")').length > 0) {
        


    
    //       var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
    //       jQuery(".downAnimated").each(function () {
    //         var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
    //           limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
    //         if (meTop > limitTop && meBottom < limitBottom) {
    //             me.css("transform", "translateY(0)");
    //           setTimeout(function () {
    //             me.removeClass("downAnimated");
    //           }, 1500);
    //         }
    //       })
    //      }
      
  



    var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
        limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
  
        setTimeout(function () {
          //me.removeClass("animated wowo");
        }, 1500);
      }
    });




    jQuery(".scroll-text").each(function () {
      var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
        limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {

        setTimeout(function () {
          //me.removeClass("animated wowo");
        }, 1500);
      }
    });
  }, 100);

}

function scroll() {

  jQuery(window).scroll(function () {
    var sh = jQuery(window).scrollTop();
    var ele_H = jQuery('header').innerHeight();
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > ele_H) {
      jQuery('header').addClass('sticky');
    } else {
      jQuery('header').removeClass('sticky');
    }

 
    
  });
  var sh = jQuery(window).scrollTop();
  var ele_H = jQuery('header').innerHeight();
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollTop > ele_H) {
    jQuery('header').addClass('sticky');
  } else {
    jQuery('header').removeClass('sticky');
  }



}

function click() {

  jQuery('header.color-black').addClass('flag');
  jQuery('.header__hamburger ').click(function () {
    //  click hamburger for different color
    if (jQuery('.header__search-box  .search__modal').hasClass('active')) {
      jQuery('.search__modal').removeClass('active');
    } else if (jQuery("header").hasClass('flag')) {
      jQuery(this).toggleClass('active');
      jQuery('.header__menu').toggleClass('is-active');
      jQuery('html,body').toggleClass('overflow-h');
    } else {
      jQuery(this).toggleClass('active');
      jQuery('header').toggleClass('color-black');
      jQuery('.header__menu').toggleClass('is-active');
      jQuery('html,body').toggleClass('overflow-h');
    }

  });
  // click search-box
  jQuery('.header__show-m .header__search details').click(function () {
    jQuery('.header__hamburger,.header__cart').addClass('opacity');
  });

  jQuery(".search-modal__close-button").click(function (e) {
    jQuery('.header__hamburger,.header__cart').removeClass('opacity');
    e.stopPropagation();
  });
  //  click show password
  var flag = 1;
  jQuery(".form .list .show ").click(function () {
    if (flag == 1) {
      jQuery(this).siblings('input').attr("type", "text");
      jQuery(this).addClass("hide");
      flag = 0;
    } else if (flag == 0) {
      jQuery(this).siblings('input').attr("type", "password");
      jQuery(this).removeClass('hide');
      flag = 1;
    }
  });
  //  toggle account
  jQuery('.login-and-account .btns .login-btn').click(function () {
    jQuery(this).addClass('active').siblings().removeClass('active');
    jQuery('.login-block').removeClass('hidden').siblings('.make-account').removeClass('show');
  });
  jQuery('.login-and-account .btns .create-account').click(function () {
    jQuery(this).addClass('active').siblings().removeClass('active');
    jQuery('.make-account').addClass('show').siblings('.login-block').addClass('hidden');
  });
  jQuery('.header .header__login').click(function () {
    jQuery('.pop-up').addClass('active');
  });

  jQuery('.check-and-password ').click(function () {
    jQuery('.login-form-wrap').addClass('hidden');
    jQuery('.resetpassword-form-wrap').addClass('active');

  });
  jQuery('.back-to-login').click(function () {
    jQuery('.login-form-wrap').removeClass('hidden');
    jQuery('.resetpassword-form-wrap').removeClass('active');
  });

  //  pop-up
  jQuery(".pop-up").click(function () {
    jQuery(this).removeClass('active');
  });
  jQuery(".pop-up .login-and-account").click(function (e) {
    e.stopPropagation();
  });
  jQuery('.product-details__info-list h3').click(function () {
    jQuery(this).toggleClass('active').siblings('.drop-box').stop().slideToggle();
    // jQuery(this).parent().siblings().find('h3').removeClass('active').siblings().stop().slideUp();
  });


  //  faq-list
  jQuery('.faq__content-list').each(function () {
    (jQuery(this).find('.next-section').length > 0) ? jQuery(this).addClass("next") : jQuery(this).click(function () {
      jQuery(this).find('h3').toggleClass('active').siblings('.drop-box').stop().slideToggle();
      jQuery(this).siblings().find('h3').removeClass('active').siblings().slideUp();
    });


  });


  jQuery('.faq__content-list .drop-box').click(function (e) {
    e.stopPropagation();
  });
  jQuery('.faq__content-right .faq__content-text').eq(0).addClass('active');
  jQuery('.faq__content-left ul li').eq(0).addClass('active');

  jQuery('.faq__content-left ul li').click(function () {
    jQuery(this).addClass('active').siblings().removeClass('active');
    var i = jQuery(this).index();
    jQuery('.faq__content-right .faq__content-text').eq(i).addClass('active').siblings().removeClass('active');
    var m = (i >= jQuery('.faq__content-left ul li').length - 1) ? 0 : i + 1;
    console.log(m);
    var text = jQuery('.faq__content-text').eq(m).find('h2').text();
    jQuery(".next-section").find('a').text(text);
  });

  jQuery('.next-section').click(function () {
    var index = jQuery('.faq__content-left ul li.active').index();

    index = (index >= jQuery('.faq__content-left ul li').length - 1) ? 0 : index + 1;
    jQuery('.faq__content-left ul li').eq(index).addClass('active').siblings().removeClass('active');
    jQuery('.faq__content-right .faq__content-text').eq(index).addClass('active').siblings().removeClass('active');
    var n = (index >= jQuery('.faq__content-left ul li').length - 1) ? 0 : index + 1;
    var text = jQuery('.faq__content-text').eq(n).find('h2').text();
    jQuery(".next-section").find('a').text(text);
    var ul_left = jQuery('.faq__content-left').offset().left;
    var ul_w = jQuery('.faq__content-left ul').width();
    var li_left = jQuery('.faq__content-left ul li').eq(index).offset().left;
    var transform_l = li_left - ul_left;
    jQuery('.faq__content-left ul').scrollLeft(transform_l);
  });

  //  filter
  jQuery('.filters .filter__select .select').click(function (e) {
    jQuery(this).toggleClass('active');
    jQuery(this).parents('.filters').siblings('.filter-main-box').find('.filter-box-drawdown-wrap').stop().slideToggle();

    e.stopPropagation();
  });
  jQuery('.filter-box-drawdown-wrap').click(function (e) {
    e.stopPropagation();
  });
  jQuery(document).on('click', '.facets__form .facet-filters__field', function (e) {
      jQuery(this).toggleClass('open')
      e.stopPropagation();
  }).on('click', '.facets__form .facet-filters__field .custom-select div', function (e) {
      var sortValue = jQuery(this).data('value')
      jQuery('[name="sort_by"]').val(sortValue)
      var event = new Event('input', {
          bubbles: true,
          cancelable: true,
      });
    
      jQuery('[name="sort_by"]')[0].dispatchEvent(event);

      jQuery(this).closest('.facet-filters__field').removeClass('open')
      e.stopPropagation();
    });

  jQuery(".template-search .facets__wrapper ").click(function (e) {
    jQuery(this).find('.filter-box-drawdown-wrap').stop().slideToggle();
    jQuery(this).find('.facets__heading ').toggleClass('active');
    e.stopPropagation();
  });

  jQuery('body').click(function (e) {
    jQuery('.filters .filter__select .select').removeClass('active');
    jQuery('.facets__form .facets__wrapper').find('.filter-box-drawdown-wrap ').slideUp();
    jQuery('.facets__form .facet-filters__field .select').removeClass('active');
    
    jQuery('.facets__form .facets__wrapper').find('.facets__heading ').removeClass('active');
    jQuery('.cart-item__quantity-btn .quantity').removeClass('active');
    jQuery('.cart-item__quantity-wrapper .cart-item__quantity-style').slideUp();
    console.log()
    if(!$(e.target).closest('.customize__items').length){
      jQuery('.customize-box').removeClass('active');
    }
    
  });

  // customize-box
  // jQuery('.customize-box .content').click(function (e) {
  //   //e.stopPropagation();
  // });
  jQuery('.customizing').click(function (e) {
    e.stopPropagation();
  });
  //  cart

  jQuery('.cart-item__quantity-btn .quantity').click(function (e) {
    jQuery(this).toggleClass('active').siblings().stop().slideToggle();
    e.stopPropagation();
  });
  jQuery('.cart-item__quantity-wrapper .cart-item__quantity-style li').click(function (e) {
    var text = jQuery(this).text();
    jQuery(".cart-item__quantity-btn  .quantity__input ").val(parseInt(text));
    jQuery(this).parent().slideUp();
    jQuery(this).parent().siblings().removeClass('active');
    e.stopPropagation();
  });

  //  description
  jQuery('.description').each(function () {
    jQuery(this).find('.read-more').click(function () {
      jQuery('.description p:gt(0)').slideDown();
      jQuery(this).hide();
    });
  });

  // footer-log-in
  jQuery('.footer__menu>ul>li').eq(2).find(".sub-menu li:first-child a").attr('href', "javascript:void(0);");
  jQuery('.footer__menu>ul>li').eq(2).find(".sub-menu li:first-child a").click(function () {
    jQuery('.pop-up').addClass('active');
  })

  jQuery(document).on('click', '.has-menu', function(e){
    if(!$(e.target).hasClass('megamenu-level-3') && jQuery('.header__hamburger').is(':visible')){
      e.preventDefault()
      $(this).toggleClass('hover')
    }
    
  })

  jQuery(document).on('mouseenter', '.has-menu', function(e){
    if(!jQuery('.header__hamburger').is(':visible')){

      $(this).addClass('hover')
    }
    
  })
  
  jQuery(document).on('mouseleave', '.has-menu', function(e){
    if(!jQuery('.header__hamburger').is(':visible')){
      $(this).removeClass('hover')
    }
    
  })
}

function contentMargin() {
  var header_H = jQuery('.header-block').innerHeight() + 1;

  var wh = jQuery(window).height();
  jQuery('header').hasClass('flag') ? jQuery('#MainContent').css('margin-top', header_H) : jQuery('#MainContent').css('margin-top', "0");

}

function appendEle() {

  jQuery('.product-details__info-list.list').each(function () {
    jQuery(this).find('h3').prepend('<span class="icon-plus"> </span>');
  });

  jQuery('.faq__content-right h2').before('<div class="h-line"> </div>');
  jQuery('.faq__content-right .h-line').each(function () {
    jQuery(this).nextUntil('.h-line').wrapAll(function () {
      return "<div class=' faq__content-text'> </div>";
    });
  });

  jQuery('.faq__content-text').each(function () {
    var text = jQuery(this).find('h2').text();
    jQuery('.faq__content-left ul').append("<li> <a href='javascript:void(0)' >" + text + " </a></li> ");
  });

  jQuery('.faq__content-text h3').before('<div class="t-line"> </div>');
  jQuery('.faq__content-text .next-section').before('<div class="t-line"> </div>');



  jQuery('.faq__content-text .t-line').each(function () {
    jQuery(this).nextUntil('.t-line').wrapAll(function () {
      return "<div class=' faq__content-list'> </div>";
    });
  });

  jQuery('.faq__content-text .faq__content-list p:last').after('<div class="b-line"> </div>');
  jQuery('.faq__content-text h3').each(function () {
    jQuery(this).nextUntil(".b-line").wrapAll(function () {
      return "<div class='drop-box'> </div>";
    });
  });
  (jQuery('.faq__content-text').length < 2) ? true : jQuery('.faq__content-right').append(`
 <div class="next-section">
<span>Next Section</span>
<a href="#">Ordering & Customizations </a>
 </div>
  `);

  if ( jQuery('.brand-story').hasClass('reverse')) {
      jQuery('.brand-story__text h3').removeClass('fadeInRightOpacity').addClass("fadeInLeftOpacity");
  }
  jQuery('.collection-items  h2 span').addClass("fadeInLeftOpacity wowo");
  jQuery('.collection-items  h2 i').addClass("fadeInRightOpacity wowo");   
  jQuery('.collection-items  .content').removeClass("fadeInUp wowo");   
  jQuery('.collection-items  .collection__items .collection__item').each(function () {
    var i = jQuery(this).index();
    jQuery(this).addClass('wowo fadeInUp  delay-in-'+i * 2+ ''); 
    });
}

function cookie() {
  if (jQuery.cookie('open-pop-up')) {
    jQuery('.pop-up').removeClass('active');
  } else {
    setTimeout(() => {
      jQuery('.pop-up').addClass('active');
    }, 3000);

  }
  jQuery.cookie('open-pop-up', 'pop-up', {
    expires: 1,
    path: '/'
  });
}

function video() {

  jQuery(".video-link.mp4,.is-video").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });


    var video_url = jQuery(this).find('.data-video').html();
    console.log('video_url', 'https:' + video_url)
    jQuery('.video-light-box').find('.play-iframe-video').append('<video  muted loop="loop" autoplay controls="controls" src="https:' + video_url + '"></video>');
    jQuery('.video-light-box').fadeIn(300);

    var videoElements = jQuery('.video-light-box video');
    var hls = new Hls();

    videoElements.each(function () {
      var videoSrc = jQuery(this).find('source').attr('src');
      var videoElement = this;
      if (videoSrc.endsWith('.mp4')) {

      } else {

        hls.loadSource(videoSrc);
        hls.attachMedia(videoElement);
      }
    });


  });
  jQuery(".video-link.file").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });
    var video_url = jQuery(this).find('.data-video').html();
    var caption = jQuery(this).find('.data-video').attr('data-caption');
    jQuery('.video-light-box').find('.play-iframe-video').append('<video controls="controls"><source src="' + video_url + '" type="video/mp4"> <track src="' + caption + '"  srclang="en" label="English" kind="subtitles" default /></video>');
    jQuery('.video-light-box').fadeIn(300);
  });
  jQuery(".video-link.embed").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });
    jQuery('.video-light-box').fadeIn(300);
    var html = jQuery(this).find('.data-video').html();
    console.log(html);
    jQuery('.video-light-box').find('.play-iframe-video').html(html);
  });


  jQuery('.video-light-box .icon-close').click(function () {
    jQuery(document).unbind("mousewheel DOMMouseScroll");
    jQuery(document).unbind("touchmove");
    jQuery('.video-light-box').fadeOut(300);
    setTimeout(function () {
      jQuery('.video-light-box').find('.play-iframe-video').html('');
    }, 300);
  });

  jQuery('.video-light-box').click(function () {
    jQuery(document).unbind("mousewheel DOMMouseScroll");
    jQuery(document).unbind("touchmove");
    jQuery('.video-light-box').fadeOut(300);
    setTimeout(function () {
      jQuery('.video-light-box').find('.play-iframe-video').html('');
    }, 300);
  });
  jQuery('.video-light-box .video-box').click(function (event) {
    event.stopPropagation();
  });

  jQuery(".video-link,.is-video").click(function (event) {
    event.stopPropagation();
    var vvv = jQuery(this).children(".video").find("video");
    vvv.on('loadedmetadata', function () {
      vvv.trigger('play');
    });
    // vvv.trigger('play');

    setTimeout(function () {
      var ss = jQuery(".video-light-box .video-box video");
      ss.trigger('play');
    }, 300);

  });

  jQuery(".video-show").click(function (event) {
    event.stopPropagation();
    jQuery(this).children(".text-and-img").addClass("is-active");
    var vvv = jQuery(this).parents(".video").find("video");

    if (jQuery(this).hasClass("is-active")) {
      vvv.trigger('play');
      jQuery(this).removeClass("is-active");
    } else {
      jQuery(this).addClass("is-active");
      vvv.trigger('pause');
    }

  });


}


function hlsVideo() {
  var videoElements = document.querySelectorAll('video:not(#vton-webcam-video)');

  videoElements.forEach(function (videoElement) {
    var videoSrc = videoElement.getAttribute('src');

    if (videoSrc) {
      var hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(videoElement);
    }
  });
}

function eleHover(){
  jQuery(".slider-rotate__items .slider-rotate__item").eq(0).addClass('active');
  jQuery(".slider-rotate__items .slider-rotate__item").hover(function(){
    jQuery(this).addClass('active').siblings().removeClass('active');
  },function(){
    jQuery(this).removeClass('active')
  })
}